import {
  getDemoTrackBlob,
  isWlDemoBlobRef,
  wlDemoBlobStorageKeyFromRef,
} from "./demoTrackBlobStore";

const API_URL = (process.env.REACT_APP_API_URL_BASE || "").replace(/\/+$/, "");

const isDirectAssetUrl = (url) => /^(https?:\/\/|blob:|data:|\/)/i.test(String(url || "").trim());

export const resolveBrandingAssetUrl = (maybeRelativeOrFull) => {
  if (!maybeRelativeOrFull) {
    return "";
  }
  if (isDirectAssetUrl(maybeRelativeOrFull)) {
    return maybeRelativeOrFull;
  }
  const rel = String(maybeRelativeOrFull).replace(/^\//, "");
  if (!API_URL) {
    return `/${rel}`;
  }
  return `${API_URL}/${rel}`;
};

/**
 * Resolves stored branding logo refs for display (HTTP paths or wl-demo IndexedDB blobs).
 * Caller must revoke returned URLs when they start with `blob:` and are replaced.
 */
export async function resolveBrandingLogoObjectUrl(maybeRelativeOrFull) {
  if (!maybeRelativeOrFull) {
    return "";
  }
  let raw = String(maybeRelativeOrFull).trim();
  if (isDirectAssetUrl(raw)) {
    return raw;
  }
  if (API_URL && raw.startsWith(API_URL)) {
    raw = raw.slice(API_URL.length).replace(/^\/+/, "");
  }
  const rel = raw.replace(/^\//, "");
  if (isWlDemoBlobRef(rel)) {
    const key = wlDemoBlobStorageKeyFromRef(rel);
    const blob = await getDemoTrackBlob(key);
    return blob ? URL.createObjectURL(blob) : "";
  }
  return resolveBrandingAssetUrl(rel);
}
